export enum ButtonColor {
  Neon = 'neon',
  White = 'white',
  Black = 'black',
  Red = 'red',
  Green = 'green',
}
